<template>
    <div class="blog-wrapper">

    <!-- loading... -->
    <p v-if="isListLoading" class="loading"> در حال بارگذاری ... </p>

    <!-- error -->
    <div v-if="listError" class="error">
        <p>خطا در دریافت مقالات .</p>
        <button @click="getPosts">تلاش مجدد</button>
    </div>

    <div v-else class="blog-content">
        <BlogItem v-for="blog in posts" :key="blog.p" :blog="blog"></BlogItem>
    </div>
    <PaginationBox v-if="!isListLoading && !listError" :pageCount="filter.pageCount" :currentPage="filter.currentPage" @pageChanged="onPageChange"></PaginationBox>
    </div>
</template>

<script>
import { ref, inject, onMounted } from "vue";
import axios from 'axios';
import BlogItem from './BlogItem.vue';
import PaginationBox from './PaginationBox';
    export default {
        name: "BlogList",
        components: {
            BlogItem,
            PaginationBox,
        },
        setup() {
            const isListLoading = ref(true);
            const listError = ref(false);
            const updateCanonicalLink = inject('updateCanonicalLink');

            const posts = ref([]);
            const filter = ref({
                allCount : -1,
                pageCount : -1,
                currentPage : 1,
                rowCount: 12,
                hasPagination: true,
            });

            function onPageChange(page) {
                 filter.value.currentPage = page;
                 getPosts();
            }

            function getPosts(){
                isListLoading.value = true;
                listError.value = false;
                axios({
                    method: 'POST',
                    url: `${process.env.VUE_APP_ONCLICK_API_DOMAIN}/blog`,
                    data: filter.value,
                }).then(response => {
                    posts.value = response.data.p;
                    filter.value.allCount = response.data.ac;
                    filter.value.pageCount = response.data.pc;
                    isListLoading.value = false;
                    }).catch(err => {
                        console.error('خطا در دریافت اطلاعات:', err);
                        listError.value = true;
                        isListLoading.value = false;
                });
            }

            onMounted(() => {
                getPosts();
                updateCanonicalLink('https://onclick.ir/blog');
            });

            return {
                posts,
                getPosts,
                filter,
                onPageChange,
                listError,
                isListLoading,
            };
        }
    }
</script>

<style scoped>
.blog-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-block: 50px 150px;
}

.blog-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 30px;
    margin-bottom: 70px;
    margin-inline: 15%;
}

@media screen and (min-width: 1921px) {
    .blog-content {
        width: 1344px;
        margin-inline: auto;
    }
}

@media screen and (max-width: 1024px) {
    .blog-content {
        margin-inline: 5.556%;
    }
}

@media screen and (max-width: 768px) {
    .blog-wrapper {
        margin-top: 30px;
    }
}

</style>